import React from "react";
import throttle from "lodash/throttle";
import lazyLoad from "@/utils/lazy-load";

import "./LazyLoadImage.scss";

class LazyLoadImage extends React.Component {
  throttledScroll = null;
  madeVisible = false;
  imgRef = null;

  componentDidMount() {
    if (
      "IntersectionObserver" in window &&
      "IntersectionObserverEntry" in window &&
      "intersectionRatio" in window.IntersectionObserverEntry.prototype
    ) {
      const observer = new IntersectionObserver(
        this.observerHandler.bind(this)
      );
      observer.observe(this.imgRef);
    } else {
      this.throttledScroll = throttle(() => this.lazyLoadCall(), 200);
      this.lazyLoadCall();
      window.addEventListener("scroll", this.throttledScroll);
    }
  }

  componentDidUpdate() {
    if (!"IntersectionObserver" in window && !this.madeVisible) {
      this.madeVisible = true;
      this.lazyLoadCall();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.throttledScroll);
  }

  observerHandler(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting || entry.intersectionRatio) {
        observer.unobserve(entry.target);
        if(this.props.background){
          this.imgRef.style.backgroundImage = `url(${this.props.src})`
        } else {
          this.imgRef.src = this.props.src;
          if(this.props.srcset){
            this.imgRef.srcset  = this.props.srcset;
          }
        }
        this.props.lazyCallback();
      }
    });
  }

  lazyLoadCall() {
    lazyLoad(this.imgRef, window.innerHeight + 50, this.scrollCallback);
  }

  scrollCallback = () => {
    window.removeEventListener("scroll", this.throttledScroll);
    if(this.props.background){
      this.imgRef.style.backgroundImage = `url(${this.props.src})`
    } else {
      this.imgRef.src = this.props.src;
      if(this.props.srcset){
        this.imgRef.srcset  = this.props.srcset;
      }
    }
    // console.log(this.props.srcset)
    this.props.lazyCallback();
  };

  renderBackgroundImage() {
    // Fix for iOS to make background images full height of div
    const bgStyle = this.props.background
      ? { position: "absolute" }
      : { position: "relative" };

    return (
      <div
        className="lazy-load-image__container"
        style={bgStyle}
        ref={el => {
          if (!this.imgRef && el) {
            this.imgRef = el;
          }
        }}
      />
    );
  }

  renderInlineImage() {
    return (
      <img
        src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
        data-src={this.props.src}
        className={this.props.className}
        alt={this.props.alt || ""}
        ref={el => {
          if (!this.imgRef && el) {
            this.imgRef = el;
          }
        }}
      />
    );
  }

  render() {
    const image = this.props.background
      ? this.renderBackgroundImage()
      : this.renderInlineImage();
    return image;
  }
}
export default LazyLoadImage;



// WEBPACK FOOTER //
// ./src/components/atoms/LazyLoadImage/index.js